import { gqlReq } from "~utils/api/gql-req";

interface Response {
	getCurrentUserRoutingDecision: { allowed: boolean };
}

export const getCurrentUserRoutingDecision = () =>
	gqlReq<Response>({
		query: /* GraphQL */ `
			query GetCurrentUserRoutingDecision {
				getCurrentUserRoutingDecision {
					allowed
				}
			}
		`,
		authMode: "userPool",
	});
